export default __webpack_public_path__ + "static/age-chronological-calculator-783279691c2e06f8efdec3db527dbe6b.jpeg";